export default __webpack_public_path__ + "static/media/electronics_part.46758575.png";